class LinkListComponent extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[ref="track"]');
    this.prevBtn = this.querySelector('[ref="prevBtn"]');
    this.nextBtn = this.querySelector('[ref="nextBtn"]');

    if (this.prevBtn && this.nextBtn && this.track) {
      this.prevBtn.addEventListener('click', () => this.scrollTrack(-1));
      this.nextBtn.addEventListener('click', () => this.scrollTrack(1));
    }
  }

  scrollTrack(direction) {
    const itemWidth = this.track.querySelector('.link-list__item')?.offsetWidth || 0;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    this.track.scrollBy({ left: direction * (itemWidth + gap), behavior: 'smooth' });
  }
}

if (!customElements.get('link-list-component')) {
  customElements.define('link-list-component', LinkListComponent);
}
